var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "footer_main" } }, [
    _c("nav", [
      _c("ul", [
        _c("li", [
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.route("DcTop")
                }
              }
            },
            [_vm._v("トップページ")]
          )
        ]),
        _vm._v(" "),
        !_vm.isHaseko
          ? _c("li", [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.route("DcAbout")
                    }
                  }
                },
                [_vm._v("初めての方へ")]
              )
            ])
          : _c("li", [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.route("DcAbout2")
                    }
                  }
                },
                [_vm._v("初めての方へ")]
              )
            ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.route("DcPaymentGuide")
                }
              }
            },
            [_vm._v("ご購入ガイド")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.route("Cart")
                }
              }
            },
            [_vm._v("カート")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.route("Faq")
                }
              }
            },
            [_vm._v("よくある質問")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.route("SupportInput")
                }
              }
            },
            [_vm._v("お問い合わせ")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.route("DcCorpInformation")
                }
              }
            },
            [_vm._v("会社案内")]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "copyright" } }, [
      _vm._v("Copyright ©" + _vm._s(_vm.year) + " domans all rights reserved. ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-545b3fb7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-545b3fb7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/components/common/DcFooter.vue
// module id = null
// module chunks = 